// removed by extract-text-webpack-plugin
module.exports = {"loader":"styles__loader___1agfw","rotation":"styles__rotation___2WUyH","modal":"styles__modal___2qT0H","overlay":"styles__overlay___2qbU9","overlay_opacity":"styles__overlay_opacity___34rBn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/styles.css
// module id = 884
// module chunks = 0